/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import "./UserGuide.css";

export default (props: any) =>
     <iframe title="Userguide" src="/files/userguide.pdf"  />
